module.exports = __webpack_public_path__ + "ipetbooking/admin/img/ticket.ec8140ce.svg";